/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
import { ReactNode } from 'react'

interface Props {
  isTrue: boolean | undefined | number | string | null
  children?: ReactNode
  render?: ReactNode | null
}

const RenderIf = ({ children, isTrue, render = null }: Props): any =>
  Boolean(isTrue) ? children : render

export default RenderIf
